// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'phone-in-solid';

export const Component = () => (
  <g
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeMiterlimit='4.167'
  >
    <path
      fill='currentColor'
      d='M9.627 16.944c1.424.901 3.224.676 4.349-.45l.525-.526a1.18 1.18 0 0 0 0-1.652l-2.1-2.103c-.45-.45-1.2-.45-1.65 0-.45.451-1.2.451-1.65 0L5.803 8.91a1.18 1.18 0 0 1 0-1.652 1.18 1.18 0 0 0 0-1.652l-2.1-2.103a1.176 1.176 0 0 0-1.649 0l-.525.526a3.431 3.431 0 0 0-.45 4.355 30.945 30.945 0 0 0 8.549 8.56z'
    />
    <path d='M9.927 8.084 17.5.5m-2.924 7.584H9.852V3.429' />
  </g>
);

export const viewBox = '0 0 18 18';
